import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDetectMobile, useDetectTablet } from './utils';
import TriageBot from "./TriageBotEngine";
import ProfileSelect from "./ProfileSelect";
import ProgressBar from "./ProgressBar";
import SummaryPrintable from "./print/SummaryPrintable";
import '../../stylesheets/triagebot/SympleNoteApp.scss';
import '../../stylesheets/triagebot/print/print.scss';
import axios from "../../interceptors/interceptors";
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import appInsightsService from "./../../services/appInsightsService";

const reconnectUrl = '/api/directline-reconnect';
const trigger = process.env.REACT_APP_TRIGGER;
const filter = process.env.REACT_APP_FILTER_ID;
const cdoName = process.env.REACT_APP_CDO_NAME;
const profileURL = cdoName?.toLowerCase() === "optumincubator" ? '/api/profiles' : '';
const env = process.env.REACT_APP_ASYNC_ENVIRONMENT;
const appID = process.env.REACT_APP_APP_ID;
const customerApiUrl = process.env.REACT_APP_CUSTOMER_API_URL;// https://symplenote-dev.optum.com/api/symplenotesettings
const connectionString = process.env.REACT_APP_CONNECTION_STRING;
                                    
var DisplayLogoForMobileClient;
var DisplayLogoForDesktopClient;
var DisplayIconForDesktopClient;

if (env && (env.toLowerCase() === 'production')) {
  const noop = () => { };
  ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn',
  ].forEach((method) => {
    window.console[method] = noop;
  });
}

console.log("TRIGGER: ", trigger);
console.log("FILTER: ", filter);
console.log("PROFILES: ", profileURL);
console.log("RECONNECT: ", reconnectUrl);
console.log("ENVIRONMENT: ", env);
console.log("RELEASE: 9.0.0");
console.log("BUILD: 26.08.26");

function TriageBotPage() {
  const params = new URLSearchParams(window.location.search);
  const [botkey, setBotkey] = useState(Date.now());
  const [profile, setProfile] = useState();
  const [restart, setRestart] = useState(false);
  const [progressName, setProgressName] = useState('');
  const [configsAreLoaded, setConfigsAreLoaded] = useState(false);
  const [showWelcomeIllustration, setShowWelcomeIllustration] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [showToolBar, setShowToolBar] = useState(false);
  const [progressBar, setProgressBar] = useState(false);
  const [showDebugPanel, setShowDebugPanel] = useState(false);
  const [logo, setLogo] = useState('');
  const [hoverColor, setHoverColor] = useState('');
  const [printData, setPrintData] = useState(null);
  const [showIcon, setShowIcon] = useState(false);
  const [Icon, setIcon] = useState('');
  //datadog token
  const [secretValue, setSecretValue] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const { isMobile } = useDetectMobile();
  const { isTablet } = useDetectTablet();
  const isOpenCdo = cdoName === 'Open';
  
  // Simplified class names
  const deviceClass = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
  const suffix = isOpenCdo ? '-open' : '';
  const toolbarClass = `toolbar ${deviceClass}${suffix}`;
  const containerClass = `toolbar-container${suffix}`;
  const logoContainerClass = `logo-container${suffix}`;
  const logoClass = `${deviceClass}${suffix}`;

  const headerHeight = (profileURL ? 50 : 0) + (showToolBar ? 80 : 0) - (isMobile ? 10 : 0)

  // **************************************
  // TODO: Move the config logic to it's own file
  // Configs stuff
  // Get cookie from browser
  function getCookieValue(cookieName) {
    const cookieArray = document.cookie.split(';'); // Split cookies into an array
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === cookieName) {
        return decodeURIComponent(cookiePair[1]); // Return the cookie value
      }
    }
    return null; // Cookie not found
  }




  // Get the session token

  const [token, setToken] = useState(false);
  useEffect(() => {
    function initAppState() {
      let _base64AppDataElement = document.getElementById('_appData');
      if (_base64AppDataElement) {
        let _base64AppData = _base64AppDataElement.value;
        if (_base64AppData) {
          try {
            let appData = JSON.parse(atob(_base64AppData));
            if(appData.hasError) {
              console.error('Error in app data:', appData.errorMessage);
              return;
            }
            sessionStorage.setItem('Bearer', appData.gtwyToken);
            setSecretValue(appData.ddToken);
            setToken(true);
          } catch (error) {
            console.error('Error parsing app data:', error);
          }
        }
      }
      
    }
    sessionStorage.removeItem('Bearer');
    setSecretValue(null);
    initAppState();
  }, []);


  useEffect(() => {
    // Initialize Datadog SDK after token is fetched
    if (secretValue && !isInitialized) {
      const isComingFromOpenVersion = sessionStorage.getItem('dd_open') === 'true';
      
      // Preserve the landing-page session so its replay continues as one video.
      if (!isComingFromOpenVersion) {
        document.cookie = '_dd_s=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        document.cookie = '_dd_s_v2=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      } else {
        console.log('Continuing Datadog session from open version landing page');
      }

      console.log('Initializing Datadog SDK with environment:', process.env.REACT_APP_ENVIRONMENT);
      
      // Initialize RUM - same config as working landing page
      // If coming from open version, the SDK will continue the existing Datadog session.
      datadogRum.init({
        applicationId: '25daeedf-0308-4f5f-8793-56f44c46dc34',
        clientToken: secretValue,
        site: 'datadoghq.com',
        service: 'symplenoteui',
        env: process.env.REACT_APP_ENVIRONMENT,
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        // v7 defaults to cookies only and silently sends nothing when they are
        // unavailable (e.g. embedded in a cross-site iframe). This replaces the
        // v5 `allowFallbackToLocalStorage` option.
        sessionPersistence: ['cookie', 'local-storage']
      });
      
      datadogRum.startSessionReplayRecording();
      
      // Initialize Logs - same config as working landing page
      datadogLogs.init({
        clientToken: secretValue,
        site: 'datadoghq.com',
        service: 'symplenoteui',
        env: process.env.REACT_APP_ENVIRONMENT,
        version: '1.0.0',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: 'all',
        sessionSampleRate: 100,
        // Logs now require a session manager in v7; keep the same fallback
        // chain as RUM so both stay on the same session.
        sessionPersistence: ['cookie', 'local-storage']
      });
      
      datadogRum.setGlobalContext({
        cdoName: cdoName            
      });
      datadogLogs.setGlobalContext({
        cdoName: cdoName
      });
      
      console.log('Datadog SDK initialized successfully');
      setIsInitialized(true);
    }
  }, [secretValue]);

    console.log('Triage Bot Page Started..')
  function toHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  function scaleInt(c, magnitude) {
    c = c + magnitude;
    c > 255 && (c = 255);
    c < 0 && (c = 1);

    return c
  }

  const brightenColor = (hexColor, magnitude) => {
    hexColor = hexColor.replace(`#`, ``);

    if (hexColor.length === 6) {

      let rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
      rgb = rgb ? {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
      } : null;

      rgb.r = scaleInt(rgb.r, magnitude);
      rgb.g = scaleInt(rgb.g, magnitude);
      rgb.b = scaleInt(rgb.b, magnitude);

      return `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`;

    } else {
      return hexColor;
    }
  };

  const hexColorToRgba = (hexColor, alpha) => {
    hexColor = hexColor.replace(`#`, ``);

    if (hexColor.length === 6) {

      let rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
      rgb = rgb ? {
        r: parseInt(rgb[1], 16),
        g: parseInt(rgb[2], 16),
        b: parseInt(rgb[3], 16)
      } : null;

      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;

    } else {
      return hexColor;
    }
  };
const inFlightRef = useRef(false);
const loadConfigs = useCallback(async (force = false) => {
  if (inFlightRef.current) return;                 
  if (configsAreLoaded && !force) return;         
  if (!token) return;     
    inFlightRef.current = true;
  try {
    console.log("Loading configs for appID:", appID);

    const response = await axios.get("/api/symplenotesettings", {
      params: { appID },
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
        // "Authorization": `Bearer ${bearer}`
      },
      withCredentials: true,
      timeout: 10000
    });

    updateConfigs(response.data);
    setConfigsAreLoaded(true);
  } catch (err) {
    console.error("Error loading configs:", err);
  } finally {
    inFlightRef.current = false;
  }
}, [configsAreLoaded, token, appID ]);

  const updateConfigs = (configs) => {
    const root = document.documentElement;

    setHoverColor(configs.buttonColor);

    console.log(configs);
    DisplayLogoForMobileClient = configs.displayLogoForMobileClient;
    DisplayLogoForDesktopClient = configs.displayLogoForDesktopClient;
    DisplayIconForDesktopClient = configs.DisplayIconForDesktopClient;

    //card-trim-color
    if (configs.cardTrimColor)
      root.style.setProperty('--card-trim-color', configs.cardTrimColor);

    //font family
    if (configs.fontFamily)
      root.style.setProperty('--font-family', configs.fontFamily);
    if (configs.fontFamily)
      root.style.setProperty('--header-font-family', configs.fontFamily);
    if (configs.fontFamily)
      root.style.setProperty('--button-font-family', configs.fontFamily);

    //text-color
    if (configs.bodyTextColor)
      root.style.setProperty('--text-color', configs.bodyTextColor);
    if (configs.bodyTextColor)
      root.style.setProperty('--header-font-color', configs.bodyTextColor);

    //button Color
    if (configs.buttonColor) {
      root.style.setProperty('--provider-button-hover-color', hexColorToRgba(configs.buttonColor, .08));
      root.style.setProperty('--button-hover-background', configs.buttonColor);
      root.style.setProperty('--button-hover-color2', brightenColor(configs.buttonColor, -12));
    }

    if(configs.headerTextColor) {
      root.style.setProperty('--button-active-color2', brightenColor(configs.headerTextColor, -12));
      root.style.setProperty('--button-hover-border-color', configs.headerTextColor);
      root.style.setProperty('--button-active-color', configs.headerTextColor);
      root.style.setProperty('--button-active-border-color', configs.headerTextColor);
      root.style.setProperty('--primary-color', configs.headerTextColor);
      root.style.setProperty('--header-text-color', configs.headerTextColor);
    }

    //displayWelcomeIllustration - true/false
    const welcomeIllustration = configs.displayWelcomeIllustration;
    setShowWelcomeIllustration(welcomeIllustration);

    //logo
    const IncomingLogo = configs.logo;
    setLogo(IncomingLogo);
    const IncomingIcon = configs.Icon
    setIcon(IncomingIcon)

    //headerOptions : can be none/both/logo/progressBar, 
    const options = configs.headerOption;
    if (options === 'both') {
      setShowToolBar(true);
      setShowLogo(true);
      setProgressBar(true);
      setShowIcon(true);
    }
    if (options === 'progressbar') {
      setShowToolBar(true);
      setProgressBar(true);
    }
    if (options === 'logo') {
      setShowToolBar(true);
      setShowLogo(true);
    }
    if (options === 'Icon') {
      setShowToolBar(true);
      setShowIcon(true);
    }
    const favIcon = configs.favIcon;

    var link = document.querySelector("link[rel~='icon']");
    if (favIcon) {
      link.href = `${favIcon}`;
    }
  }

  // ***** End of configs stuff
  // ********************************

  const profileChanged = (profile) => {
    setProfile(profile);
    setRestart(true);
  }

  const updateProgress = (name) => {
    datadogRum.setViewContextProperty("progress", name);
    setProgressName(name);
    console.log("CURRENT STEP: ", name);
  }

  const setSummaryPrintData = (data) => {
    const type = data?.type?.toLowerCase();
    if (type !== 'summary' && type !== 'summaryopen') return;

    setPrintData(data);
  }

    useEffect(() => {
        if (!profileURL) {
            loadConfigs().catch(console.error);
        }
    }, [profileURL,loadConfigs]);

// Restart trigger
useEffect(() => {
  if (restart) {
    loadConfigs().catch(console.error);            
    setBotkey(Date.now());
    setRestart(false);
  }
}, [restart, loadConfigs]);
  return (
    
    <div id='triage-bot-page' className='page'>
      <header>
      {
         profileURL && token &&
        <div className='logobar'>

          {
            params.has('debug')
              ? <button className='button' onClick={() => setShowDebugPanel(true)}>Debug panel</button>
              : ''
          }

          <ProfileSelect key='profile-selector' classes='proselect' profileChanged={profileChanged} />
        </div>
      }
      {
        showToolBar &&
        <div className={toolbarClass} >
          <div className={containerClass}>
            {
              isMobile ?
                DisplayLogoForMobileClient &&
                <div className='logo'>
                  {
                    logo && showLogo && (
                    <>
                        <div className={logoContainerClass}>
                          <img className={logoClass} src={`${logo}`} alt='Optum' />
                          <span className="smart-symptom">Symptom Smart</span>
                        </div>
                    </>
                  )}
                </div>
                : DisplayLogoForDesktopClient &&
                <div className='logo'>
                  {
                    logo && showLogo && (
                    <>
                        <div className={logoContainerClass}>
                          <img className={logoClass} src={`${logo}`} alt='Optum' />
                          <span className="smart-symptom">Symptom Smart</span>
                        </div>
                    </>
                  )}
                </div>
            }
            {
              !isMobile &&
              DisplayIconForDesktopClient &&
              <div className="Icon">
                {
                  Icon && showIcon &&
                  <img className={logoClass} src={`${Icon}`} alt='Atrius Icon' />
                }
              </div>
            }
            <div className='progress'>
              {
                progressBar &&
                <ProgressBar progressName={progressName} size={isMobile ? 130 : 150} />
              }
            </div>
          </div>
        </div>
      }
      </header>

      <main id="page-body" className='page-body' style={{ top: headerHeight }}>
        {/* TODO: Can we change HoverColor from state variable to css variable (--provider-button-hover-color)? */}
        { token &&
        <TriageBot setSummaryPrintData={setSummaryPrintData} updateProgress={updateProgress} showDebug={showDebugPanel} setShowDebug={setShowDebugPanel} setRestart={setRestart} key={botkey} profile={profile} showWelcomeIllustration={showWelcomeIllustration} HoverColor={hoverColor}/>
        }
      </main>

      <div id='printable-body' role='region' aria-label='Print summary' className={params.has('showprint') ? 'showprint' : ''}>
        <SummaryPrintable data={printData} logo={logo} key={new Date()} />
      </div>
    </div>
  );
}
export default TriageBotPage;
